module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-f4769f9bdb7466be65088239c12046d1.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/scss/fonts/bootstrap/glyphicons-halflings-regular.eot
 ** module id = 165
 ** module chunks = 1 2 6 7 12 23 42 48 62
 **/